
import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import YahrzeitDisplayPage from "@/components/pages/YahrzeitDisplayPage";

interface YahrzeitDisplayEditorProps {
  content: any;
  onContentChange: (field: string, value: any) => void;
}

interface MockData {
  id: string;
  name: string;
  father_name: string | null;
}

const YahrzeitDisplayEditor: React.FC<YahrzeitDisplayEditorProps> = ({ content, onContentChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showPreview, setShowPreview] = useState(true);

  const defaultMockData = [
    { id: "1", name: "משה לוי", father_name: "אברהם" },
    { id: "2", name: "שרה כהן", father_name: "יצחק" },
  ];

  const mockData = content?.mockData || defaultMockData;

  const handleTogglePreview = () => {
    setShowPreview(!showPreview);
    if (!content) {
      onContentChange("", {
        previewMode: !showPreview,
        mockData: defaultMockData
      });
    } else {
      onContentChange("", {
        ...content,
        previewMode: !showPreview
      });
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <Switch
                id="preview-mode"
                checked={showPreview}
                onCheckedChange={handleTogglePreview}
              />
              <Label htmlFor="preview-mode">תצוגה מקדימה</Label>
            </div>
            <p className="text-sm text-muted-foreground">
              הגדרות תצוגת יאהרצייט
            </p>
          </div>

          <p className="text-sm text-muted-foreground mb-4">
            דף זה יציג שמות נפטרים שיום יאהרצייט שלהם חל היום לפי התאריך העברי.
            מוצגים רק רשומות שאושרו ע״י מנהל המערכת.
          </p>
        </CardContent>
      </Card>

      {showPreview && (
        <Card>
          <CardContent className="pt-6">
            <h3 className="font-medium mb-4">תצוגה מקדימה:</h3>
            <div className="border rounded-md p-4 bg-gray-50 h-[400px] overflow-auto">
              <YahrzeitDisplayPage 
                content={{ 
                  previewMode: true,
                  mockData: mockData
                }} 
                isPreview={true} 
              />
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default YahrzeitDisplayEditor;
